import { render, staticRenderFns } from "./lamsRegLegalLitigationInfo.vue?vue&type=template&id=70f49af0&scoped=true&"
import script from "./lamsRegLegalLitigationInfo.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalLitigationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f49af0",
  null
  
)

export default component.exports